import { render, staticRenderFns } from "./SampleModalSearch.vue?vue&type=template&id=b0d12b30&scoped=true&"
import script from "./SampleModalSearch.vue?vue&type=script&lang=js&"
export * from "./SampleModalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d12b30",
  null
  
)

export default component.exports